import { Box, Typography, TextField, Button, Grid, Link, Paper, Divider } from "@mui/material"
import {Link as RouterLink} from "react-router-dom";
import logo from "../../../assets/images/logo.jpeg"
import login from "../../../assets/images/login.png"
export default function LoginPage() {
  return (
    <Grid container component="main" sx={{ height: "100vh" }}>
      {/* Left side - Image */}
      <Grid
        item
        xs={false}
        sm={false}
        md={6}
        sx={{
          position: "relative",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: { xs: "none", md: "block" },
        }}
      >
        <img
          src={login}
          alt="Student with laptop"
          fill
          style={{ objectFit: "cover" }}
          priority
        />
      </Grid>

      {/* Right side - Login form */}
      <Grid item xs={12} md={6} component={Paper} elevation={0} square>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            px: 4,
            maxWidth: 500,
            mx: "auto",
          }}
        >
          {/* Logo */}
          <Box sx={{ mb: 6, width: "100%", maxWidth: 120, mx: "auto" }}>
            <img
              src={logo}
              alt="E1X Academy Logo"
              width="120"
              height="60"
              style={{ objectFit: "contain" }}
            />
          </Box>

          <Typography component="h1" variant="h4" fontWeight="bold" sx={{ mb: 1 }}>
            Welcome Back!
          </Typography>

          <Typography component="h2" variant="h5" sx={{ mb: 6 }}>
            Log in to E1X
          </Typography>

          {/* Login Form */}
          <Box component="form" noValidate sx={{ width: "100%" }}>
            <Typography variant="body1" sx={{ mb: 1, color: "#000000", fontWeight: "bold", fontFamily: "Monserrat, sans-serif" }}>
              Email
            </Typography>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              placeholder="Enter Your email"
              name="email"
              autoComplete="email"
              autoFocus
              variant="outlined"
              sx={{ mb: 4, borderColor: "#E84A1C", "&:hover": { borderColor: "#D43D10" }, "&:focus": { borderColor: "#E84A1C" }}}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                py: 1.5,
                mt: 2,
                mb: 4,
                backgroundColor: "#E84A1C",
                "&:hover": {
                  backgroundColor: "#D43D10",
                },
                textTransform: "none",
                fontSize: "1rem",
              }}
            >
              Log In
            </Button>

            <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
              <Typography variant="body1" color="text.secondary" sx={{ mr: 1 }}>
                Don't have an account?
              </Typography>
              <Link  component={RouterLink} to={"/talents/register"} variant="body1" sx={{ color: "#E84A1C", textDecoration: "none" }}>
                Sign Up
              </Link>
            </Box>

            <Divider sx={{ my: 3 }} />
          </Box>
        </Box>
      </Grid>
    </Grid>
  )
}
